// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const TopCallToActionExplainer = require('./explainer')
const TopCallToActionJumpToGrid = require('./jump-to-grid')

const bem = BemEntity('TopCallToActionExperimentASplitLeading')

function TopCallToActionExperimentASplitLeading(props) {
  return tag('div', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('logo-lockup')
    },
      tag('div', {
        className: bem.element('logo-icon')
      }),
      tag('div', {
        className: bem.element('logo-text')
      })
    ),
    tag(TopCallToActionExplainer, {
      className: bem.element('explainer')
    }),
    tag(TopCallToActionJumpToGrid, {
      className: bem.element('jump-to-grid'),
      href: '#discover'
    })
  )
}

module.exports = TopCallToActionExperimentASplitLeading
